import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'

import { EBResponsiveHighlightComponent } from './eb-responsive-highlight.component'

@NgModule({
  imports: [
    CommonModule,
    EbResponsiveMediaComponent,
    GenericLinkModule,
    EBResponsiveHighlightComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        EBResponsiveHighlightComponent: {
          component: EBResponsiveHighlightComponent
        }
      }
    } as CmsConfig)
  ]
})
export class EBResponsiveHighlightModule {}
